import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { GroupIBFraudPreventionService } from "@obg/ngx.common";
import { AUTH_ACTION_TYPE, AuthSelector, CoreState, SESSION_ACTION_TYPE } from "@obg/ngx.core";
import { tap, withLatestFrom } from "rxjs/operators";

// Hardcoded because these can not be imported from other module
const REGISTRATION_ACTION_TYPE = {
	getRegistrationToken: "[Registration] Get Registration Token",
	registerFail: "[Registration] Register Fail",
	registerSuccess: "[Registration] Register Success",
};

@Injectable()
export class GroupIBFraudPreventionEffect {
	sessionStart$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(AUTH_ACTION_TYPE.sessionStart),
				withLatestFrom(this.store.select(AuthSelector.getSessionToken)),
				tap(([_action, sessionToken]) => this.service.setAuthorized(sessionToken))
			),
		{ dispatch: false }
	);

	sessionEnd$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(
					AUTH_ACTION_TYPE.sessionEnd,
					SESSION_ACTION_TYPE.sessionExpired,
					SESSION_ACTION_TYPE.loginFail,
					SESSION_ACTION_TYPE.loginWithVerificationCodeFail,
					SESSION_ACTION_TYPE.loginWithPersonalNumberFail,
					SESSION_ACTION_TYPE.loginWithTokenFail,
					SESSION_ACTION_TYPE.loginWithAuthenticationTokenFail,
					REGISTRATION_ACTION_TYPE.registerFail
				),
				tap(() => this.service.setUnauthorized())
			),
		{ dispatch: false }
	);

	registrationEnd$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(REGISTRATION_ACTION_TYPE.registerSuccess),
				tap(() => this.service.setNewToken())
			),
		{ dispatch: false }
	);

	constructor(
		private actions$: Actions,
		private store: Store<CoreState>,
		private service: GroupIBFraudPreventionService
	) {}
}
